import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import SurveyResponseResults, {
  QuestionResponseResult,
} from '../../../Surveys/util/SurveyResponseResults';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Divider } from '@lifeomic/chroma-react/components/Divider';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(0.5, 0),
    width: '100%',
    '& > *:last-child': {
      marginRight: theme.spacing(4),
    },
    '& > *:first-child': {
      marginLeft: theme.spacing(4),
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: theme.pxToRem(1200),
    },
  },
  value: {
    color: theme.palette.text.primary,
  },
}));

export type InLineQuestionLineItemOwnProps = {
  lineItems: QuestionResponseResult[];
  parentHasScoring: boolean;
};

const InLineQuestionLineItem: React.FC<InLineQuestionLineItemOwnProps> = ({
  lineItems,
  parentHasScoring,
}) => {
  const classes = useStyles({});

  return (
    <>
      <Divider />
      <Box className={classes.root} gap={2}>
        {lineItems.map((item, index) => {
          return (
            <Box
              key={index}
              direction="column"
              fullWidth
              align="center"
              gap={1}
            >
              <Text size="subbody" weight="bold">
                {item.label}
              </Text>
              {SurveyResponseResults.isValueQuestionResult(item) && (
                <>
                  <Text className={classes.value} size="caption">
                    {item.value}
                  </Text>
                  {parentHasScoring && (
                    <Text className={classes.value} size="caption">
                      {item.score}
                    </Text>
                  )}
                </>
              )}
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default InLineQuestionLineItem;
